<template>
  <div class="mainTab" :style="{backgroundColor:getBackgroundColor}">
    <div class="mainTab">
      <div class="tab-header">
        <div class="tab-wrapper">
          <div class="no-scroll">
            <div role="tablist" class="nav" style="display: flex;" :style="{flexDirection:direction}">
              <div :data-name="item.id" class="item" @click="tabClick(item.id)" v-for="(item,index) in chartConfig.data"
                :key="index" style="background-size: 100% 100%;background-repeat: no-repeat;" :style="{color:getFontColor(item.id),fontSize:getFontSize,
                borderBottom:getBorderBottomColor(item.id),
                borderTop:getBorderTopColor(item.id),
                borderLeft:getBorderLeftColor(item.id),
                borderRight:getBorderRightColor(item.id),
                margin:getMargin,
                padding:getPadding,
                height:getItemHeight,
                backgroundImage:'url('+getBackgroundImage(item)+') ',

                width:getItemWidth}"
                >
                {{item.label?item.label:''}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
  export default {
    props: {
      width: {
        type: String,
        default: '100%'
      },
      height: {
        type: String,
        default: '100%'
      },
      chartConfig: {
        type: Object,
        default: function() {
          return {

            data: []
          }
        }
      },
      screen: {
        type: Object,
        default () {
          return {
            height: 1920,
            width: 1280,
          }
        }
      },
      page: {
        type: Object,
        default () {
          return {
            height: 1920,
            width: 1280,
          }
        }
      }
    },
    data() {
      return {
        activeName: (this.chartConfig.data && this.chartConfig.data.length > 0) ? this.chartConfig.data[0].id : ''
      }
    },
    mounted() {
      //this.activeName = (this.chartConfig && this.chartConfig.length > 0) ? this.chartConfig.data[0].id : ''
    },
    watch: {
      chartConfig: {
        handler(newValue, oldValue) {
          this.activeName = (this.chartConfig.data && this.chartConfig.data.length > 0) ? this.chartConfig.data[0].id :
            ''
        },
        deep: true
      }
    },
    computed: {
      getItemWidth(){
        if(this.chartConfig && this.direction==='row' && this.chartConfig.data){
          return (1/this.chartConfig.data.length)*100+'%'
        }
        return '100%'
      },
      getItemHeight(){
        let _height=this.chartConfig.itemHeight
        if(_height){
          return _height / this.page.height * this.screen.height+'px';
        }
        return null
      },
      // getBackgroundColor() {
      //   return this.chartConfig.backgroundColor ? this.chartConfig.backgroundColor : ''
      // },

      direction(){
        if(this.chartConfig&& this.chartConfig.direction){
          return this.chartConfig.direction
        }
        return 'row'
      },
      getFontSize() {
        return (this.chartConfig.fontSize ? this.chartConfig.fontSize : 14) + 'px'
      },
      getMargin(){
        return (this.chartConfig.margin ? this.chartConfig.margin : '0')
      },
      getPadding(){
        return (this.chartConfig.padding ? this.chartConfig.padding : '0 20px')
      }
    },
    methods: {
      getBackgroundImage(item){
        if(item.bg){
          if(item.clickbg){
            if (this.activeName === item.id) {
              return item.clickbg
            }else{
              return item.bg
            }
          }else{
            return item.bg
          }
        }
        return null
      },
      getBorderBottomColor(id) {
        if (this.activeName === id) {
          return (this.chartConfig.borderSelectBottom ? this.chartConfig.borderSelectBottom : '');
        } else {
          return (this.chartConfig.borderBottom ? this.chartConfig.borderBottom : '');
        }
      },
      getBorderTopColor(id) {
        if (this.activeName === id) {
          return (this.chartConfig.borderSelectTop ? this.chartConfig.borderSelectTop : '');
        } else {
          return (this.chartConfig.borderTop ? this.chartConfig.borderTop : '');
        }
      },
      getBorderLeftColor(id) {
        if (this.activeName === id) {
          return (this.chartConfig.borderSelectLeft ? this.chartConfig.borderSelectLeft : '');
        } else {
          return (this.chartConfig.borderLeft ? this.chartConfig.borderLeft : '');
        }
      },
      getBorderRightColor(id) {
        if (this.activeName === id) {
          return (this.chartConfig.borderSelectRight ? this.chartConfig.borderSelectRight : '');
        } else {
          return (this.chartConfig.borderRight ? this.chartConfig.borderRight : '');
        }
      },
      getBackgroundColor(id) {
        if (this.activeName === id) {
          return this.chartConfig.backgroundSelectColor ? this.chartConfig.backgroundSelectColor : 'rgba(0,0,0,0)';
        } else {
          return this.chartConfig.backgroundColor ? this.chartConfig.backgroundColor : 'rgba(0,0,0,0)';
        }
      },
      getFontColor(id) {
        //debugger
        if (this.activeName === id) {
          return this.chartConfig.fontSelectColor ? this.chartConfig.fontSelectColor : '#409EFF';
        } else {
          return this.chartConfig.fontColor ? this.chartConfig.fontColor : '#303133';
        }
      },
      tabClick(id) {
        this.activeName = id
        this.$emit("tabClick", id)
      }
    }

  }
</script>

<style scoped="scoped" lang="scss">
  .is-active {
    border-bottom: 2px solid red;
  }

  .mainTab {
    width: 100%;
    height: 100%;

    .tab-header {
      padding: 0;
      position: relative;
      margin: 0 0 15px;

      .tab-wrapper {
        overflow: hidden;
        margin-bottom: -1px;
        position: relative;

        .no-scroll {
          overflow: hidden;

          .nav {
            white-space: nowrap;
            position: relative;
            transition: -webkit-transform .3s;
            transition: transform .3s;
            transition: transform .3s, -webkit-transform .3s;
            // float: left;
            z-index: 2;
            display: flex;
            align-items: center;
            justify-content: center;

            .item {
              background-size: 100% 100%;background-repeat: no-repeat;
              padding: 0 20px;
              height: 40px;
              -webkit-box-sizing: border-box;
              box-sizing: border-box;
              line-height: 40px;
              display: inline-block;
              list-style: none;
              cursor: pointer;
              font-size: 14px;
              font-weight: 500;
              color: #303133;
              position: relative;
            }

            .is-active {
              color: #409EFF;
              border-bottom: 2px solid red;
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Tabs.vue